import React, { useMemo } from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';

// TODO: включить после реализации функционала рассылки
import SubscribeFormFull from 'components/Forms/SubscribeFormFull';
import WpImage from 'components/WPImage';
import Icon from 'components/UI/Icon';
import { TEMPLATES_PAGE } from 'constants/urls';

import * as styles from './lead.module.scss';

const Lead = ({ data, pageUrl, lang }) => {
  const {
    templateLeadGeneratorHero: {
      templateLeadGeneratorHeroBanner,
      templateLeadGeneratorHeroBackButton,
      templateLeadGeneratorHeroTitle,
      templateLeadGeneratorHeroDescription,
    },
  } = data;

  const fileUrl =
    data?.templateLeadGeneratorAttachFileToDownload?.mediaItemUrl ??
    'https://screver.com/404/';

  const backLinkUrl = useMemo(() => {
    if (lang.slug === 'de') {
      return `${TEMPLATES_PAGE}?locale=de`;
    } else if (lang.slug === 'en') {
      return TEMPLATES_PAGE;
    }
  }, [lang]);

  return (
    <div className={classnames(styles.leadHero, 'scr-template-hero-inner')}>
      <div
        className={classnames(styles.media, 'scr-template-hero-inner__media')}
      >
        <WpImage
          src={templateLeadGeneratorHeroBanner?.sourceUrl || '#'}
          alt={templateLeadGeneratorHeroBanner?.altText}
        />
      </div>

      <div className={classnames('scr-template-hero-inner__content')}>
        <Link
          className={classnames('scr-template-conten-btn-back scr-link')}
          to={backLinkUrl}
          id="link-template-back"
        >
          <Icon name="chevron-left" /> {templateLeadGeneratorHeroBackButton}
        </Link>

        <h3 className={classnames('scr-template-conten-title scr-h3')}>
          {templateLeadGeneratorHeroTitle}
        </h3>

        <div
          className={classnames(styles.description)}
          dangerouslySetInnerHTML={{
            __html: templateLeadGeneratorHeroDescription,
          }}
        ></div>

        {/* TODO: включить после реализации функционала рассылки */}
        <div>
          <SubscribeFormFull
            fileUrl={fileUrl}
            articleTitle={templateLeadGeneratorHeroTitle}
            pageUrl={pageUrl}
          />
        </div>
      </div>
    </div>
  );
};

export default Lead;
